// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Star Systems Data - Legacy Compatibility Layer
 * 
 * This file now imports from the universe system for backward compatibility.
 * New code should import from 'config/universes' instead.
 * 
 * @deprecated Use getUniverseData() from 'config/universes' instead
 */

import { getAllLocations, getAllPositions } from './universes';

// Default to milkyway universe for backward compatibility
// Components should migrate to using universe-aware functions
export const starSystems = getAllLocations('milkyway');
export const starPositions = getAllPositions('milkyway');
